import { Theme, css } from '@emotion/react';

import { fontStyles } from '~src/theme/fontStyles';
import { mediaQueries } from '~src/theme/mediaQueries';
import { getBorderColor, getLabelColor } from '~src/ui/common-styles';

export const inputAndLabelWrapper = css({
  position: 'relative',
  display: 'flex',
  flex: 1,
});

export const inputCss = (textarea?: boolean, disabled?: boolean) => (theme: Theme) =>
  css({
    border: 'none',
    color: disabled ? theme.grey : theme.black, // TODO: WCAG - matter to change
    backgroundColor: disabled ? theme.superlightGrey : 'transparent',
    height: textarea ? undefined : '100%',
    width: '100%',
    outline: 'none',
    transition: 'all 0.2s',
    WebkitAppearance: 'none',
    boxSizing: 'border-box',
    padding: '30px 40px 12px 16px',
    ...fontStyles.px14_20,
    resize: 'none',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    pointerEvents: disabled ? 'none' : 'initial',
    [mediaQueries.S]: {
      ...fontStyles.px16_20, // disable auto-zoom on ios.
    },
  });

export const labelCss =
  (raiseLabel: boolean, error?: boolean, warning?: boolean, disabled?: boolean) => (theme: Theme) =>
    css({
      top: raiseLabel ? '11px' : '50%',
      transform: `translate(0, ${raiseLabel ? '0' : '-50%'})`,
      left: '16px',
      right: '16px',
      position: 'absolute',
      transition: 'all .1s ease-in-out',
      pointerEvents: 'none',
      cursor: 'text',
      color: getLabelColor(!!error, warning, disabled)(theme),
      ...(raiseLabel ? fontStyles.px12_16 : fontStyles.px16_20),
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    });

export const extensionStyles = css({
  position: 'absolute',
  right: '15px',
  top: '22px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
});

export const styles = {
  wrapper:
    (focused: boolean, error: boolean, warning: boolean, textarea?: boolean, disabled?: boolean) =>
    (theme: Theme) =>
      css({
        position: 'relative',
        height: textarea ? undefined : '60px',
        width: '100%',
        display: 'flex',
        backgroundColor: 'transparent',
        borderColor: getBorderColor(focused, error, warning, disabled)(theme),
        borderStyle: 'solid',
        borderWidth: '1px',
        borderRadius: '2px',
      }),

  wordCount: css({
    marginLeft: '3px',
  }),
};
